import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import CategoryIcon from '../components/CategoryIcon';
import { getExpertTopics, saveExpertTopics } from '../api/client';

export default function ExpertTopicsPage({ onNavigate }) {
  const [available, setAvailable] = useState([]);
  const [selected, setSelected] = useState([]);
  const [max, setMax] = useState(4);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    getExpertTopics()
      .then(d => {
        setAvailable(d.available || []);
        setSelected(d.topics || []);
        if (d.max) setMax(d.max);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const toggle = (cat) => {
    setSaved(false);
    setSelected(prev => {
      if (prev.includes(cat)) return prev.filter(c => c !== cat);
      if (prev.length >= max) return prev; // лимит — больше не добавляем
      return [...prev, cat];
    });
  };

  const handleSave = () => {
    setSaving(true);
    setSaved(false);
    saveExpertTopics(selected)
      .then(d => {
        if (d && d.topics) setSelected(d.topics);
        setSaved(true);
        setTimeout(() => setSaved(false), 2500);
      })
      .catch(() => {
        const tg = window.Telegram?.WebApp;
        if (tg?.showAlert) tg.showAlert('Не удалось сохранить. Попробуйте ещё раз.');
      })
      .finally(() => setSaving(false));
  };

  const atLimit = selected.length >= max;

  return (
    <div>
      <Header
        title="Мои темы эксперта"
        left={
          <div onClick={() => onNavigate('home')}
            style={{ fontSize: 15, color: 'var(--accent)', cursor: 'pointer', minWidth: 50 }}>
            ← Назад
          </div>
        }
      />
      <div style={{ padding: '16px 16px 100px', display: 'flex', flexDirection: 'column', gap: 16 }}>

        {/* Интро-карточка: зачем выбирать темы */}
        <div style={{
          background: 'var(--bg-card)', borderRadius: 16, padding: '14px 16px',
          border: '1px solid var(--border)', display: 'flex', gap: 12, alignItems: 'flex-start',
          animation: 'fadeInUp 0.35s ease both',
        }}>
          <div style={{
            width: 40, height: 40, borderRadius: 12, background: 'var(--accent-dim)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent)',
          }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
              <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
            </svg>
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
            Выберите до {max} тем, по которым вы готовы помогать участникам клуба.
            Когда участник задаст вопрос по вашей теме — вам придёт уведомление в бот.
          </div>
        </div>

        {loading ? (
          <div style={{ color: 'var(--text-tertiary)', fontSize: 15, textAlign: 'center', marginTop: 40 }}>Загрузка…</div>
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>Мои темы</div>
              <div style={{
                fontSize: 12, fontWeight: 700, padding: '4px 10px', borderRadius: 20,
                background: atLimit ? 'var(--accent-dim)' : 'var(--bg-card)',
                color: atLimit ? 'var(--accent)' : 'var(--text-tertiary)',
                border: '1px solid ' + (atLimit ? 'var(--accent)' : 'var(--border)'),
              }}>
                {selected.length} / {max}
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {available.map((cat, i) => {
                const active = selected.includes(cat);
                const disabled = !active && atLimit;
                return (
                  <div key={cat} onClick={() => !disabled && toggle(cat)}
                    style={{
                      position: 'relative',
                      display: 'flex', flexDirection: 'column', gap: 10,
                      padding: '14px 14px 12px', borderRadius: 16,
                      border: '1px solid ' + (active ? 'var(--accent)' : 'var(--border)'),
                      background: active ? 'var(--accent-dim)' : 'var(--bg-card)',
                      cursor: disabled ? 'default' : 'pointer',
                      opacity: disabled ? 0.45 : 1,
                      transition: 'border-color 0.15s ease, background 0.15s ease, opacity 0.15s ease',
                      animation: `fadeInUp 0.35s ease ${0.03 * i}s both`,
                    }}>
                    <div style={{
                      width: 40, height: 40, borderRadius: 12,
                      background: active ? 'var(--accent)' : 'var(--accent-dim)',
                      color: active ? '#0A0A0A' : 'var(--accent)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      transition: 'background 0.15s ease, color 0.15s ease',
                    }}>
                      <CategoryIcon category={cat} size={21} />
                    </div>
                    <div style={{
                      fontSize: 13.5, fontWeight: 600, lineHeight: 1.25,
                      color: active ? 'var(--accent)' : 'var(--text-primary)',
                    }}>
                      {cat}
                    </div>
                    {active && (
                      <div style={{
                        position: 'absolute', top: 10, right: 10,
                        width: 20, height: 20, borderRadius: '50%',
                        background: 'var(--accent)', color: '#0A0A0A',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                      }}>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="m5 13 4 4L19 7" />
                        </svg>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <button
              onClick={handleSave}
              disabled={saving}
              style={{
                marginTop: 8, padding: '14px 0', borderRadius: 12, border: 'none',
                background: 'var(--accent)', color: '#0A0A0A',
                fontSize: 15, fontWeight: 700, cursor: saving ? 'default' : 'pointer',
                opacity: saving ? 0.6 : 1,
              }}>
              {saved ? 'Сохранено ✓' : (saving ? 'Сохранение…' : 'Сохранить')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
